import { Company } from "./company";
import { Customer } from "./customer";
import { Delivery } from "./delivery";
import { Product } from "./product";

export class Order {
    id: number;
    idExternal:string;
    orderDate: Date; //dt_order
    company: Company; //company_id
    customer: Customer; //customer_id
    
    products: Array<Product> = []; //list of products
    
    deliveryAddress: string; //delivey_address
    deliveryNumber: string;
    deliveryComplement: string; 
    deliveryNeighborhood: string; 
    deliveryCity: string;
    deliveryState: string; 
    deliveryCountry: string; 
    deliveryZipcode: string;
    deliveryLat: string;
    deliveryLng: string;
    totalPrice: number; //total_value
    totalQuantity:number;
    paymentMethod: string; //payment_method
    delivery:Delivery;
    deliverySort: number;
    totalWeight: number;

    deliveryEstimatedDuration: number;
    deliveryEstimatedDistance: number;
    deliveryEstimatedDurationText: string;
    deliveryEstimatedDistanceText: string;

    deliveryEstimatedArrivedDate: Date; 

    constructor(id: number,
        orderDate: Date,
        company: Company,
        customer: Customer,
        products: Array<Product>,
        deliveryAddress: string,
        deliveryNumber: string, 
        deliveryComplement: string, 
        deliveryNeighborhood: string, 
        deliveryCity: string, 
        deliveryState: string, 
        deliveryCountry: string, 
        deliveryZipcode: string,
        deliveryLat: string,
        deliveryLng: string,
        paymentMethod: string,
        delivery: Delivery,
        deliverySort: number,
        totalPrice: number,
        totalWeight: number,
        totalQuantity: number,
        idExternal:string) {
            this.id = id;
            this.orderDate = orderDate; //dt_order
            this.company = company; //company_id
            this.customer = customer; //customer_id
            this.products = products;
            this.deliveryAddress = deliveryAddress; //delivey_address
            this.deliveryNumber = deliveryNumber; //delivery_number
            this.deliveryComplement = deliveryComplement; //delivery_complement
            this.deliveryNeighborhood = deliveryNeighborhood; //delivery_neighborhood
            this.deliveryCity = deliveryCity; //delivery_city
            this.deliveryState = deliveryState; //delivery_state
            this.deliveryCountry = deliveryCountry; //delivery_country
            this.deliveryZipcode = deliveryZipcode;
            this.deliveryLat = deliveryLat;
            this.deliveryLng = deliveryLng;
            this.totalPrice = totalPrice; //total_value
            this.paymentMethod = paymentMethod; //payment_method
            this.delivery = delivery;
            this.deliverySort = deliverySort;
            this.totalWeight = totalWeight;
            this.totalQuantity = totalQuantity;
            this.idExternal = idExternal;
        }
    get idCustom():any {
        if (this.idExternal && this.idExternal.length > 0) {
            return this.idExternal;
        } else {
            return this.id;
        }
    }

    getCompanyName():string {
        if (this.company && this.company.name) {
            return this.company.name;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/order.ts